<template>
  <div>
    <b-modal id="accountant-react" centered hide-footer>
      <template #modal-header="">
        <h5>Kế toán phản hồi nhận/không nhận</h5>
        <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
      </template>
      <div class="button">
        <b-button @click="downloadTemp" class="b-button" variant="outline-secondary"
          >Tải file mẫu</b-button
        >
      </div>
      <div class="button">
        <b-button @click="importFile" class="b-button" variant="outline-secondary"
          >Import file</b-button
        >
        <input style="display: none" ref="uploadFileExcel" @change="uploadFileExcel" type="file" />
      </div>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { ContractService } from '@/services/contract.service'
  export default {
    data() {
      return {
        showLoading: false,
      }
    },
    methods: {
      async downloadTemp() {
        try {
          this.showLoading = true
          await ContractService.downloadFileTemplateAccountantReact()
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      importFile() {
        this.$refs.uploadFileExcel.click()
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showFailMx('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        try {
          this.showLoading = true
          const res = await ContractService.importFileAccountantReact(formdata)
          if (res.code === 1000) {
            console.log(123, res)
            this.showMsgOk(res.data.data)
            // this.$router.push('/kpi-record/upload/detail/' + res.data.fileServiceId)
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.message)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.showLoading = false
        }
      },
      uploadStatusFile() {
        this.$emit('uploadStatusFile')
      },
      closeModal() {
        this.$emit('closeModal')
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Kết quả' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, ['Đã tải dữ liệu xong']),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', `${data.correctList && data.correctList.length ? data.correctList.length : 0}`),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', `${data.errorList && data.errorList.length ? data.errorList.length : 0}`),
            ' bản ghi',
          ]),
          // data.errorList.length > 0 && &&
          h(
            'button',
            {
              class: 'f12 font-medium btn btn-outline-danger',
              on: {
                click: () => this.dowloadFileError(data.errorList),
              },
            },
            'Tải bản ghi thất bại'
          ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await ContractService.downloadAccountReactError(reqs)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .button {
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }
  .b-button {
    min-width: 225px;
  }
</style>
